import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import FinanceTagsApi from '@/services/apiServiceModules/financeTagsApi.js'

const financeTagsApi = new FinanceTagsApi()

export default class FinanceTagsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.FINANCE_TAGS, financeTagsApi, {
			useCache: true,
		})
	}
}
